import * as i from "../../../../../contracts";
import { scoreHelper } from "../../../../../helpers";
import { renderMiniScore } from "./renderMiniScore";

export const renderMiniLiveScore = function (event: i.Event) {
    const score = scoreHelper(event);
    return renderMiniScore(score.homeScore, score.awayScore, event.sportId, event.scoreboard)
}